import { horizontalEllipsis } from '@ipfabric/frontend-shared-assets/utils/characters';
import type { JSX } from 'react';

/**
 * Column types to have different human-readable representation
 */
const columnTypeTranslations: { [key: string]: string } = {
  ip: 'IP address',
  ipv6: 'IPv6 address',
  'ipv6-routing': 'IPv6 routing',
};

export const apiTableMessages = {
  en: {
    actions: {
      advancedFilter: 'Advanced filter',
      selectFilter: 'Select filter',
      exportToCsv: 'Export to CSV',
      addIntentRule: 'Add intent verification rule',
      tableDescription: 'Table description',
      urlForView: 'Get view URL',
    },
    urlForView: {
      copiedNotification: 'Table view URL was copied to clipboard',
    },
    description: {
      tableDescriptionTitle: 'Table Description',
      readTitle: 'Get table data',
      apiDocumentationTitle: 'API Documentation',
      requestPayloadTitle: 'Request Payload',
      typeTitle: (type: string): string =>
        `Filter options for ${columnTypeTranslations[type] ?? type} type`,
    },
    urlOptions: {
      parseError: 'Invalid options provided in URL.',
    },
    advancedFilter: {
      title: 'Advanced Filter',
      closeBtn: 'Close',
      filterBtn: 'Filter',
      saveAsBtn: `Save as${horizontalEllipsis}`,
      deleteBtn: 'Delete',
      saveBtn: 'Save',
      saveFilterModal: {
        title: 'Save new filter rule',
        saveBtn: 'Save',
        cancel: 'Cancel',
        required: 'Required',
      },
      deleteDialog: {
        header: 'Filter will be deleted',
        subHeader: 'Do you really want to delete selected filter?',
        btnConfirm: 'Delete',
        btnSecondaryConfirm: 'Cancel',
      },
      updateDialog: {
        header: 'Filter will be updated',
        subHeader: (filterName: string): JSX.Element => (
          <>
            Do you really want to update filter &quot;
            <strong>{filterName}</strong>
            &quot;?
          </>
        ),
        btnConfirm: 'Update',
      },
    },
    intentVerification: {
      addRule: 'Add',
      table: {
        name: 'Rule Name',
        column: 'Colorized Column',
        results: 'Result',
        actions: 'Actions',
      },
      userDefinedRule: 'User defined rule',
      tableTitle: 'Intent Verification Rules',
      reportSummary: 'Results summary:',
      form: {
        defaultColor: 'Default color',
        description: 'Description',
        success: 'Success',
        info: 'Info',
        warning: 'Warning',
        error: 'Error',
        ruleName: 'Rule name',
        colorizedColumn: 'Colorized column',
        dashboardWidgets: 'Dashboard Widgets',
        required: 'Required',
        maxLength: (n: number): string =>
          `Cannot be longer than ${n} characters`,
        atLeastOneFilter: 'At least one color filter has to be set',
        invalidFilter: 'Invalid filter',
        defaultColorDescription: (): JSX.Element => (
          <>
            Default color is given to a cell that doesn’t match any of the
            preset filters.
            <br />
            No other action is required!
          </>
        ),
      },
      actions: {
        cancel: 'Cancel',
        delete: 'Delete',
        updateRule: 'Update',
        createRule: 'Create',
      },
      heading: {
        title: 'Intent Rule Detail',
        subtitle: 'Specify a filter rule to colorize selected column',
      },
    },
    tables: {
      inventory: {
        sites: {
          actions: {
            showDevices: 'Show devices',
            showDiagram: 'Show diagram',
            downloadReport: 'Download report',
          },
        },
      },
    },
  },
};
